import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { API_URL } from './config';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function OpenShift() {
    const navigate = useNavigate(); 
    const companyId = localStorage.getItem('company_id');
    const userId = localStorage.getItem('user_id'); 
    const [branchName, setBranchName] = useState(localStorage.getItem('branchName'));
    const [companyName, setCompanyName] = useState(localStorage.getItem('companyName')); 
    const [username, setUsername] = useState(localStorage.getItem('userName')); 
    const branchId = localStorage.getItem('branch_id'); 

    useEffect(() => {
        const existingShiftDetails = localStorage.getItem('shiftDetails');
        if (existingShiftDetails) {
            const shiftDetails = JSON.parse(existingShiftDetails);
            navigate('/pos', { state: { shiftDetails } });
        }
    }, [navigate]);

    const handleOpenShift = async () => {
        const dateTimeOpen = new Date().toISOString();
        const shiftComment = "Opened by " + username; 
        const data = {
            company_id: companyId,
            branch_id: branchId, 
            operator_id: userId, 
            shift_status: "open",
            date_time_open: dateTimeOpen,
            date_time_close: '', 
            shift_comment: shiftComment, 
            syncid: 'abc123', 
        };

        console.log('Local Storage Values:', {
            companyId,
            userId,
            companyName,
            branchName,
        });
        console.log('Data being sent:', data);

        try {
            const response = await fetch(`${API_URL}/shift`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            localStorage.setItem('shiftId', result.shift_id);
            localStorage.setItem('dateTimeOpen', dateTimeOpen);
            localStorage.setItem('branchId', data.branch_id);

            const shiftDetails = {
                shift_id: result.shift_id,
                company_id: companyId,
                branch_id: data.branch_id,
                branch_name: branchName, 
                operator_id: userId,
                date_time_open: dateTimeOpen,
                date_time_close: '', 
                shift_comment: shiftComment,
                syncid: 'abc123',
            };
            localStorage.setItem('shiftDetails', JSON.stringify(shiftDetails)); 

            console.log('Shift Details stored in local storage:', shiftDetails);

            await Swal.fire({
                title: 'Success!',
                text: 'Shift opened successfully!',
                icon: 'success',
                confirmButtonText: 'OK'
            });

            // Pass additional details to PosHome
            navigate('/pos', { 
                state: { 
                    shiftDetails, 
                    companyName, 
                    branchName, 
                    operatorName: username 
                } 
            }); 

        } catch (error) {
            console.error('Error opening shift:', error);
            Swal.fire('Error', 'Failed to open shift. Please try again.', 'error');
        }
    };

    return (
        <Container>
            <header className="text-center my-4">
                <h1>Rems POS</h1>
                <h1>Initializing Shift</h1>
            </header>

            <div className="mb-3" align="center" style={{ margin: '100px auto', width: '50%' }}>
                <h5>Confirm Shift Details</h5>
                <p><strong>Name:</strong> {username}</p>
                <p><strong>Company:</strong> {companyName}</p>
                <p><strong>Branch:</strong> {branchName}</p>

                <Button 
                    className="btn btn-success me-2" 
                    style={{ marginTop: '20px' }} 
                    onClick={handleOpenShift} 
                    disabled={!branchId} // Disable if branchId is not set
                >
                    Open Shift
                </Button>
            </div>
        </Container>
    );
}

export default OpenShift;